module.exports = __webpack_public_path__ + "static/img/avatar-bar.619c63ee.png";